import httpRequestMethodEnum from './enums/httpRequestMethod';
import httpContentTypeEnum from './enums/httpContentType';
import fetchModeEnum from './enums/fetchMode';
import { apiEndpointEnum } from './enums/apiEndpoints';
import { apiHeadersEnum } from './enums/apiHeaders';
import { baseURLEnum } from './enums/baseURL';
import { getBaselineJWT, baselineJWTExpiredWrapper } from './libJWT';
import { baseURL, logger,  getApiConfiguration} from '../baselineApis';
import { wrappedTypeResponse } from './enums/wrappedTypeResponse';

const convertToFormData = (formDataElementsObject) => {
  const formData = new FormData();
  Object.keys(formDataElementsObject).forEach((elementKey) =>
    formData.append(elementKey, formDataElementsObject[elementKey]),
  );

  return formData;
};

function createBearerHeader(authToken)
{
  return `Bearer ${authToken}`;
}


const _get = async () => {
  return getBaselineJWT().then((authToken) => {
    const url = baseURL(baseURLEnum.USER_STORE)+`/${apiEndpointEnum.USER_STORE}`;
    const headers = {
      authorization: createBearerHeader(authToken),
      [apiHeadersEnum.CONTENT_TYPE]: httpContentTypeEnum.APPLICATION_JSON,
      accept: '*/*',
    };
    
    logger.info({
      url: url,
      function: _get.name,
      method: httpRequestMethodEnum.GET,
    });

    const request = new Request(url, {
      method: httpRequestMethodEnum.GET,
      headers: headers,
      mode:fetchModeEnum.CORS
    });

    return fetch(request);
  });
};

const _set = async (key, value) => {
  return getBaselineJWT().then((authToken) => {
    const url = baseURL(baseURLEnum.USER_STORE)+`/${apiEndpointEnum.USER_STORE}`;
    const headers = {
      authorization: createBearerHeader(authToken),
      accept: '*/*',
    };

    let obj = {};
    obj[key] = value;
    const formData = convertToFormData(obj);

    logger.info({
      url: url,
      function: _set.name,
      method: httpRequestMethodEnum.POST,
      data: formData,
    });

    const request = new Request(url, { 
      method: httpRequestMethodEnum.POST,
      body: formData,
      headers: headers,
      url: url,
      mode:fetchModeEnum.CORS
    });

    return fetch(request);
  });  
};

const _delete = async (key) => {
  return getBaselineJWT().then((authToken)=>{

    const url = baseURL(baseURLEnum.USER_STORE)+`/${apiEndpointEnum.USER_STORE}/${key}`;
    const headers = {
      authorization: createBearerHeader(authToken),
    };

    logger.info({
      url: url,
      function: _delete.name,
      method: httpRequestMethodEnum.DELETE,
    });

    const request = new Request(url, {
      method: httpRequestMethodEnum.DELETE,
      url:url,
      headers:headers,
      mode:fetchModeEnum.CORS
    });

    return fetch(request);
  });
};

export const userStoreAPI = {
  get: baselineJWTExpiredWrapper(_get, wrappedTypeResponse.JSON),
  set: baselineJWTExpiredWrapper(_set, null),
  delete: baselineJWTExpiredWrapper(_delete, null),
};
